module.exports = __webpack_public_path__ + "img/report-8.ac93f95e.jpg";